import { get } from '../index';

export const getConversationByRoomId = (roomId) => {
  return get(`/conversation/${roomId}`);
};

export const getGuestConversationByRoomId = (roomId) => {
  return get(`/guest-chat/${roomId}`);
};
